import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";

// #TSP-620 - temp work around to redirect old DXP link format to the new DXP link format
//anything with topicTeaser needs to be redirected
export const TopicTeaserRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCalledRef = useRef(false);

  useEffect(() => {
    // if guideline level -> `/guidelines/${cleanedGuidelinePage}`
    if (!isCalledRef.current) {
      isCalledRef.current = true;
      const guidelinePage = searchParams.get("guidelinePage");
      const isGuidelineRootLevelRedirect =
        guidelinePage && !(searchParams.get("topicfile") || searchParams.get("sectionId")); // if these params don't exist assume this is root level URL
      if (isGuidelineRootLevelRedirect) {
        const cleanedGuidelinePage = decodeURIComponent(guidelinePage).trim().replace(" ", "_");
        const newUrl = `/guidelines/${cleanedGuidelinePage}`;
        navigate(newUrl, { replace: false });
        return;
      }
      // umbrella level URLs is not supported :(
      // else assume viewTopic

      const queryString = window.location.search;
      const newUrl = `/viewTopic${queryString}`;
      navigate(newUrl, { replace: false });
    }
  }, [navigate, searchParams]);

  return null;
};
